/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { VistaControllerPushMutationRequest, VistaControllerPushMutationResponse, VistaControllerPushPathParams, VistaControllerPush400, VistaControllerPush401, VistaControllerPush403 } from "../../models/changeOrdersController/VistaControllerPush";

function getVistaControllerPushUrl(id: VistaControllerPushPathParams["id"]) {
  const res = { method: 'POST', url: `/api/v1/potential-change-orders/${id}/vista/push` as const }  
  return res
}

/**
 * {@link /api/v1/potential-change-orders/:id/vista/push}
 */
export async function vistaControllerPush(id: VistaControllerPushPathParams["id"], data: VistaControllerPushMutationRequest, config: Partial<RequestConfig<VistaControllerPushMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<VistaControllerPushMutationResponse, ResponseErrorConfig<VistaControllerPush400 | VistaControllerPush401 | VistaControllerPush403>, VistaControllerPushMutationRequest>({ method : "POST", url : getVistaControllerPushUrl(id).url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}